import * as React from 'react';
import { Image, Pressable, View, StyleSheet } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as AppState from "../context/AppState";
import { AppContext } from "../context/AppContext";
import { useSelector, useDispatch } from 'react-redux';

const styles = StyleSheet.create({
  image: {
    width: 32,
    height: 32,
    alignSelf: "center",
  },
  imageSimple: {
    width: 32,
    height: 32,
  },
  labelWrapper: {
    backgroundColor: "white",
    flex: 1,
    alignItems: "center",
  },
  label: {
    fontSize: 10,
  },
  checkImage: {
    width: 16,
    height: 16
  },
  verticalView: {
    flexDirection: "column",
    gap: AppConstants.FILTER_IMAGES_GAP,
    padding: AppConstants.FILTER_IMAGES_WRAPPER_PADDING,
  },
  horizontalView: {
    flexDirection: "row",
    gap: AppConstants.FILTER_IMAGES_GAP,
    padding: AppConstants.FILTER_IMAGES_WRAPPER_PADDING,
  },
});

const HIT_SLOP = { top: 5, bottom: 5, left: 5, right: 5 };

export function FilterSlider({ vertical }) {
  const { toggleModal } = React.useContext(AppContext);
  const [selectedValue, setSelectedValue] = React.useState(null);
  const dataFilter = useSelector((state) => state.dataFilter);
  const globalDispatch = useDispatch();

  React.useEffect(() => {
    if (dataFilter) {
      if (dataFilter[AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectedValue(AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY]);
      } else if (dataFilter[AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectedValue(AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY]);
      } else if (dataFilter[AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY]] == "y") {
        setSelectedValue(AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY]);
      }
    }
  }, [dataFilter]);

  function toggle(pendingNewValue, pendingNewIndex) {
    const usedQuickFilterBefore = AppUtilities.getLocalData(AppConstants.LOCAL_DATA_KEYS.USED_QUICK_FILTER_BEFORE, false);
    if (!usedQuickFilterBefore) {
      AppUtilities.updateLocalData(AppConstants.LOCAL_DATA_KEYS.USED_QUICK_FILTER_BEFORE, true);
      toggleModal(pendingNewIndex);
    } else {
      setSelectedValue(pendingNewValue);
      AppState.changeCertificationGroup(dataFilter, pendingNewValue, globalDispatch);
    }
  }

  function togglePasture() {
    toggle(AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY], 0);
  }

  function toggleOutdoors() {
    toggle(AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY], 1);
  }

  function toggleIndoors() {
    toggle(AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY], 2);
  }

  const viewStyle = vertical ? styles.verticalView : styles.horizontalView;

  return (
    <View style={viewStyle}>
      <Pressable onPress={togglePasture} hitSlop={HIT_SLOP}>
        {
          // https://iconduck.com/emojis/36073/sunrise-over-mountains
          // https://iconduck.com/icons/71745/sign-check
          selectedValue == AppConstants.GROUP_TYPES.PASTURE[AppConstants.TYPE_KEYS.URL_KEY] ?
              <Image source={require('../../assets/sunpasture_checked.png')} style={styles.imageSimple} />
            :
              <Image source={require('../../assets/sunpasture.png')} style={styles.imageSimple} />
        }
      </Pressable>
      <Pressable onPress={toggleOutdoors} hitSlop={HIT_SLOP}>
        {
          // https://iconduck.com/emojis/17299/black-sun-with-rays
          // https://iconduck.com/icons/71745/sign-check
          selectedValue == AppConstants.GROUP_TYPES.OUTDOORS[AppConstants.TYPE_KEYS.URL_KEY] ?
              <Image source={require('../../assets/sun_checked.png')} style={styles.imageSimple} />
            :
              <Image source={require('../../assets/sun.png')} style={styles.imageSimple} />
        }
      </Pressable>
      <Pressable onPress={toggleIndoors} hitSlop={HIT_SLOP}>
        {
          // https://iconduck.com/icons/254794/shopping-store-factory
          // https://iconduck.com/icons/71745/sign-check
          selectedValue == AppConstants.GROUP_TYPES.INDOORS[AppConstants.TYPE_KEYS.URL_KEY] ?
              <Image source={require('../../assets/factory_checked.png')} style={styles.imageSimple} />
            :
              <Image source={require('../../assets/factory.png')} style={styles.imageSimple} />
        }
      </Pressable>
    </View>
  );
}
